import React from 'react';
import { SubscriptionStatus } from '../../lib/supabase';

interface SubscriptionBadgeProps {
  status: SubscriptionStatus;
  size?: 'sm' | 'md' | 'lg';
}

export const SubscriptionBadge: React.FC<SubscriptionBadgeProps> = ({ status, size = 'md' }) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };

  const statusConfig = {
    trial: {
      label: 'Trial',
      colorClass: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
    },
    active: {
      label: 'Active',
      colorClass: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
    },
    canceled: {
      label: 'Canceled',
      colorClass: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
    },
    past_due: {
      label: 'Past Due',
      colorClass: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
    },
    expired: {
      label: 'Expired',
      colorClass: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
    },
  };

  const config = statusConfig[status];

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${sizeClasses[size]} ${config.colorClass}`}
    >
      {config.label}
    </span>
  );
};
